import { render, staticRenderFns } from "./ScheduleArticlesModal.vue?vue&type=template&id=654ebcd9&scoped=true&"
import script from "./ScheduleArticlesModal.vue?vue&type=script&lang=js&"
export * from "./ScheduleArticlesModal.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleArticlesModal.vue?vue&type=style&index=0&id=654ebcd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ebcd9",
  null
  
)

export default component.exports